<template>
    <tr>
        <th>{{ $translate('cons', 'Nackdelar') }}</th>
        <td v-for="card in allCards" :key="`${card.id}`">
            <ul>
                <li v-for="(item, index) in getCons(card)" :key="index">
                    <i class="fas fa-times-circle cross-mark" />
                    <span>{{ item }}</span>
                </li>
            </ul>    
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        allCards: {
            type: Array,
            required: true
        }
    },
    methods: {
        getCons(card) {
            return card.data.cons_condensed
                .filter((item) => item.pro && item.pro[0]?.text)
                .map((item) => item.pro[0].text);
        }
    }
};
</script>